import {uuidRegex} from '../constants';

export function IsValidUUID(uuid: string): boolean {
  return RegExp(`^${uuidRegex}$`).test(uuid);
}
